import React from 'react';
import _ from 'lodash';

import {
  USER_ROLES,
  PREFECTURE_GROUPS, // 都道府県
  EXISTANCE_FLAG,
  AcceptanceForeignWorkersFlag, // 外国人就労者受入有無
  ATTACH_DOCUMENT_TYPE_COMPANY,
  REGIONAL_DEVELOPMENT_BUREAU_NONE,
  EXISTANCE_EXCLUSION_FLAG,
} from '../../utilities/constants';

import { Tel } from '../Tel'; // 電話番号入力フィールド
import { PostalCode } from '../PostalCode'; // 郵便番号入力フィールド
import AttachDocument from '../../components/forms/AttachDocument';
import { Description } from '../../components/Description';
import { DateInput } from '../DateInput';
import { FormSelect } from '../FormSelect';
import CompanyLogo from '../image/CompanyLogo';
import {
  getInsuranceStatus,
  isConstructionIndustryPermissionStatus,
  showPrefectureInput,
  showRegionalDevelopmentBureau,
  filterComboBoxHealthInsuranceTypeWhenExclusion,
} from '../../utilities/companySafetyUtil';
import {
  FormElement,
  FormList,
  FormListItem,
  FormListItemChild,
  FormListItemGroup,
  FormListSubHeader,
  FormElementContainerItem,
  FormElementContainer,
} from '../CommonFormComponents';
import { RadioButtonIcon } from '../icons/RadioButtonIcon';
import { ArrowDownIcon } from '../icons/ArrowDownIcon';
import CompanyLicenseInformation from '../CompanyLicenseInformation';
import { OldAttachmentPermission } from '../OldAttachmentPermission';
import { messageUtility } from '../../utilities/messageUtility';

const TextInput = props => {
  if (props.disabled) {
    return <span>{props.value}</span>;
  }
  return <input {...props} />;
};

/**
 * 会社情報確認
 *  元請
 * 画面遷移
 *  1.  本社管理者でログイン > 会社情報確認 > 本社情報
 * @param roleId {int} ユーザーロール
 * @param values {object} 入力値
 * @param events {func} イベントハンドラ
 * @param messages {object} バリデーションメッセージ
 * @param image {string} 画像パス
 * @param readOnly {boolean} プレビュー表示
 * @param PrimeCompanySaftyForm
 * @param use_greenfile_flg
 */
export const PrimeCompanyForm = ({
  roleId,
  values,
  events,
  messages = {},
  image,
  readOnly = false,
  PrimeCompanySaftyForm,
  use_greenfile_flg,
}) => {
  const safetyDocItemFlag = use_greenfile_flg === 1;

  return (
    <div className='contruction-detail-view__main contruction-detail-view__main--fixed'>
      <FormList
        style={{
          marginBottom: use_greenfile_flg ? '0' : '',
          height: use_greenfile_flg ? 'auto' : '',
        }}
      >
        <FormListItem
          label='会社名'
          safetyDocItem={safetyDocItemFlag}
          required={!readOnly}
        >
          <FormElement validate={messages.name}>
            <TextInput
              value={values.name}
              id='company_name'
              type='text'
              name='name'
              disabled={readOnly}
              maxLength={255}
              onChange={e => events.setCompany(e)}
              onBlur={() => events.validate('name')}
            />
          </FormElement>
        </FormListItem>
        <FormListItem label='会社名ふりがな' required={!readOnly}>
          <FormElement validate={messages.kana}>
            <TextInput
              id='company_kana'
              type='text'
              name='kana'
              disabled={readOnly}
              value={values.kana}
              maxLength={512}
              onChange={e => events.setCompany(e)}
              onBlur={() => events.validate('kana')}
            />
          </FormElement>
        </FormListItem>
        <FormListItem label='郵便番号' required={!readOnly}>
          <PostalCode
            value={values.postal_code}
            handleOnChange={events.setCompany}
            setKey='postal_code'
            readOnly={readOnly}
            placeholder='135-0061'
            error={messages.postal_code}
            validate={() => events.validate('postal_code')}
          />
        </FormListItem>
        <FormListItem
          label='都道府県'
          safetyDocItem={safetyDocItemFlag}
          required={!readOnly}
        >
          <FormElement validate={messages.prefectures_code_id}>
            <select
              name='prefectures_code_id'
              disabled={readOnly}
              value={values.prefectures_code_id}
              onChange={e => events.setCompany(e)}
              onBlur={() => events.validate('prefectures_code_id')}
            >
              <option value=''>選択してください</option>
              {_.map(PREFECTURE_GROUPS, (region, index) => (
                <optgroup key={index} label={region.label}>
                  {_.map(region.prefectures, prefecture => (
                    <option key={prefecture.id} value={prefecture.id}>
                      {prefecture.name}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
            <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
          </FormElement>
        </FormListItem>
        <FormListItem
          label='市区町村'
          safetyDocItem={safetyDocItemFlag}
          required={!readOnly}
        >
          <FormElement validate={messages.city_name}>
            <TextInput
              type='text'
              name='city_name'
              disabled={readOnly}
              value={values.city_name}
              placeholder={messageUtility.getMessage('I-000-190')}
              maxLength={512}
              onChange={e => events.setCompany(e)}
              onBlur={() => events.validate('city_name')}
            />
          </FormElement>
        </FormListItem>
        <FormListItem
          label={messageUtility.getMessage('I-000-188')}
          safetyDocItem={safetyDocItemFlag}
          required={!readOnly}
        >
          <FormElement validate={messages.street_number}>
            <TextInput
              type='text'
              name='street_number'
              disabled={readOnly}
              value={_.defaultTo(values.street_number, '')}
              placeholder={messageUtility.getMessage('I-000-191')}
              maxLength={512}
              onChange={e => events.setCompany(e)}
              onBlur={() => events.validate('street_number')}
            />
          </FormElement>
        </FormListItem>
        <FormListItem
          label='建物名・部屋番号等'
          safetyDocItem={safetyDocItemFlag}
        >
          <FormElement validate={messages.building_name}>
            <TextInput
              type='text'
              name='building_name'
              disabled={readOnly}
              value={_.defaultTo(values.building_name, '')}
              placeholder='（例）赤坂ビルディング'
              maxLength={512}
              onChange={e => events.setCompany(e)}
              onBlur={() => events.validate('building_name')}
            />
          </FormElement>
        </FormListItem>
        <FormListItem label='電話番号' required={!readOnly}>
          <Tel
            value={values.tel}
            handleOnChange={events.setCompany}
            setKey='tel'
            readOnly={readOnly}
            error={messages.tel}
            validate={() => events.validate('tel')}
            placeholder=''
          />
        </FormListItem>
        <FormListItem label='FAX番号'>
          <Tel
            value={values.fax}
            readOnly={readOnly}
            handleOnChange={events.setCompany}
            setKey='fax'
            error={messages.fax}
            validate={() => events.validate('fax')}
            placeholder=''
          />
        </FormListItem>
        {roleId === USER_ROLES.prime.id && (
          <FormListItem label='協力会社コード'>
            <FormElement validate={messages.common_partner_company_code}>
              <TextInput
                type='text'
                name='common_partner_company_code'
                disabled={readOnly}
                value={_.defaultTo(values.common_partner_company_code, '')}
                onChange={e => events.setCompany(e)}
                onBlur={() => events.validate('common_partner_company_code')}
              />
            </FormElement>
          </FormListItem>
        )}
        <CompanyLogo
          readOnly={readOnly}
          errorMessage={messages.image}
          image={image}
          onFileUpDate={events.setImage}
          onFileDelete={events.deleteImage}
        />
      </FormList>
      {use_greenfile_flg && PrimeCompanySaftyForm}
    </div>
  );
};

/**
 * 労務安全フォーム
 * @param values {object} 入力値
 * @param messages
 * @param checkboxList
 * @param comboboxList
 * @param events {func} イベントハンドラ
 * @param companyDocuments
 * @param documentCodes
 * @param bureaux 振興局
 * @param readOnly {boolean} プレビュー表示
 * @param eventCompanyBranchPermissionCommon {object}
 * @param selectedCompanyId {string}
 */
export const PrimeCompanySaftyForm = ({
  values,
  messages = {},
  checkboxList,
  comboboxList,
  events,
  companyDocuments,
  documentCodes,
  bureaux,
  readOnly = false,
  eventCompanyBranchPermissionCommon,
  selectedCompanyId,
}) => {
  const findStatus = value => {
    // checkboxListはAPIから返却されるデータのため読み込むまで空
    if (!_.isEmpty(checkboxList.insurance_statuses)) {
      return checkboxList.insurance_statuses.find(item => item.value === value);
    }
    return null;
  };

  //健康保険で加入フラグの値によって保険種類に表示する絞り込みを行う必要がある
  let healthInsuranceTypesComboBoxList = _.cloneDeep(
    comboboxList.health_insurance_types
  );
  //加入状況が「適用除外」
  if (
    values.company_branch_insurance.health_insurance_flag ===
    EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
  ) {
    healthInsuranceTypesComboBoxList = filterComboBoxHealthInsuranceTypeWhenExclusion(
      healthInsuranceTypesComboBoxList,
      values.company_branch_insurance.health_insurance_reason_exclusion
    );
  }

  /**
   * 健康、年金、雇用の保険加入状況で選択されている項目のオブジェクト
   * {id, key, value, name}
   */
  const selectedHealthInsurance = findStatus(
    values.company_branch_insurance.health_insurance_flag
  );
  const selectedPensionInsurance = findStatus(
    values.company_branch_insurance.pension_flag
  );
  const selectedEmploymentInsurance = findStatus(
    values.company_branch_insurance.employment_insurance_flag
  );

  /**
   * 安全書類項目の表示、非表示制御用オブジェクト
   */
  const insuranceStatus = getInsuranceStatus({
    selectedHealthInsurance,
    selectedPensionInsurance,
    selectedEmploymentInsurance,
  });

  const constructionIndustryPermissionStatus = isConstructionIndustryPermissionStatus(
    values.company_detail.construction_industry_permission_flag
  );

  /**
   * 健康保険_保険種類を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceType = () => {
    if (insuranceStatus.healthPresence || insuranceStatus.healthExclusion) {
      return true;
    }
    return false;
  };

  /**
   * 健康保険_事業所整理記号を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceOfficeSymbol = () => {
    if (
      insuranceStatus.healthExclusion &&
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        '５人未満個人事業所' &&
      values.company_branch_insurance.health_insurance_type === '国民健康保険'
    ) {
      return false;
    }
    if (insuranceStatus.healthPresence || insuranceStatus.healthExclusion) {
      return true;
    }
    return false;
  };
  /**
   * 健康保険_事業所番号を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceOfficeNumber = () => {
    if (
      insuranceStatus.healthExclusion &&
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        '５人未満個人事業所' &&
      values.company_branch_insurance.health_insurance_type === '国民健康保険'
    ) {
      return false;
    }
    if (insuranceStatus.healthPresence || insuranceStatus.healthExclusion) {
      return true;
    }
    return false;
  };
  /**
   * 健康保険_保険者名称を表示するべきかどうかを判定する
   * @return {boolean} true：表示するべき、false：表示しない
   */
  const showHealthInsuranceNameInsurer = () => {
    if (
      insuranceStatus.healthExclusion &&
      values.company_branch_insurance.health_insurance_reason_exclusion ===
        '５人未満個人事業所' &&
      values.company_branch_insurance.health_insurance_type === '国民健康保険'
    ) {
      return false;
    }
    if (insuranceStatus.healthPresence || insuranceStatus.healthExclusion) {
      return true;
    }
    return false;
  };

  const renderCompanyConstructionIndustry = () => {
    return (
      <React.Fragment>
        <CompanyLicenseInformation
          events={events}
          values={values}
          readOnly={readOnly}
          bureaux={bureaux}
          checkboxList={checkboxList}
          industryDefault={comboboxList.construct_permit_industry_types}
          companyDocuments={companyDocuments}
          documentCodes={documentCodes}
          eventCompanyBranchPermissionCommon={
            eventCompanyBranchPermissionCommon
          }
          selectedCompanyId={selectedCompanyId}
        />
      </React.Fragment>
    );
  };

  return (
    <FormList>
      <FormListSubHeader title='代表者情報' />
      <FormListItem label='代表者'>
        <FormElement>
          <TextInput
            type='text'
            name='delegate_name'
            maxLength={255}
            disabled={readOnly}
            value={values.company_detail.delegate_name}
            onChange={e => events.setFormValue('company_detail', e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='代表者フリガナ'>
        <FormElement
          validate={
            messages.company_detail
              ? messages.company_detail.delegate_name_kana
              : null
          }
        >
          <TextInput
            type='text'
            name='delegate_name_kana'
            maxLength={255}
            disabled={readOnly}
            value={values.company_detail.delegate_name_kana}
            onChange={e => events.setFormValue('company_detail', e)}
            onBlur={() => events.validate('company_detail')}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='代表者役職'>
        <FormElement>
          <TextInput
            type='text'
            name='delegate_post'
            maxLength={255}
            disabled={readOnly}
            value={values.company_detail.delegate_post}
            onChange={e => events.setFormValue('company_detail', e)}
          />
        </FormElement>
      </FormListItem>
      {renderCompanyConstructionIndustry()}
      <OldAttachmentPermission
        companyDocuments={values.old_company_permission_documents}
        documentCodes={documentCodes}
        events={events}
        readOnly={readOnly}
        hasSecurityPermission={false}
        hasOtherIndustryPermission={false}
      />
      <FormListSubHeader title='健康保険情報' />
      <FormListItem
        label='健康保険加入状況'
        safetyDocItem={true}
        data-testid='health_insurance_flag'
      >
        <FormElement>
          {_.map(checkboxList.insurance_statuses, (answer, index) =>
            readOnly ? (
              values.company_branch_insurance.health_insurance_flag ===
                answer.value && <span key={index}>{answer.name}</span>
            ) : (
              <div className='form-list-radio__item' key={index}>
                <label className='radio'>
                  <input
                    type='radio'
                    id={`form-radio-health_insurance_flag-${answer.id}`}
                    value={answer.value}
                    name='health_insurance_flag'
                    checked={
                      values.company_branch_insurance.health_insurance_flag ===
                      answer.value
                    }
                    onChange={e =>
                      events.setFormValue('company_branch_insurance', e)
                    }
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>{answer.name}</span>
                </label>
              </div>
            )
          )}
        </FormElement>
      </FormListItem>
      {insuranceStatus.healthExclusion && (
        <FormListItem
          label='健康保険適用除外理由'
          data-testid='health_insurance_reason_exclusion'
        >
          <FormElement>
            <TextInput
              type='text'
              list='health_insurance_reason_exclusion-list'
              name='health_insurance_reason_exclusion'
              maxLength={255}
              disabled={readOnly}
              value={
                values.company_branch_insurance
                  .health_insurance_reason_exclusion
              }
              className='TextInput--combobox'
              onChange={e => events.setFormValue('company_branch_insurance', e)}
            />
            <datalist id='health_insurance_reason_exclusion-list'>
              {_.map(
                comboboxList.health_insurance_exclusions,
                (option, index) => {
                  return (
                    <option value={option['tekiyoujogai_reason']} key={index}>
                      {option['tekiyoujogai_reason']}
                    </option>
                  );
                }
              )}
            </datalist>
          </FormElement>
        </FormListItem>
      )}
      {showHealthInsuranceType() && (
        <FormListItem label='健康保険種類' data-testid='health_insurance_type'>
          <FormElement>
            <TextInput
              type='text'
              list='health_insurance_type-list'
              name='health_insurance_type'
              maxLength={255}
              disabled={readOnly}
              value={values.company_branch_insurance.health_insurance_type}
              className='TextInput--combobox'
              onChange={e => events.setFormValue('company_branch_insurance', e)}
            />
            <datalist id='health_insurance_type-list'>
              {_.map(healthInsuranceTypesComboBoxList, (option, index) => {
                return (
                  <option value={option['name']} key={index}>
                    {option['name']}
                  </option>
                );
              })}
            </datalist>
          </FormElement>
        </FormListItem>
      )}
      {showHealthInsuranceNameInsurer() && (
        <FormListItem
          label='健康保険者名称'
          safetyDocItem={true}
          data-testid='health_insurance_name_insurer'
        >
          <FormElement>
            <TextInput
              type='text'
              name='health_insurance_name_insurer'
              maxLength={255}
              disabled={readOnly}
              value={
                values.company_branch_insurance.health_insurance_name_insurer
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
            />
          </FormElement>
        </FormListItem>
      )}
      {showHealthInsuranceOfficeSymbol() && (
        <FormListItem
          label='健康保険事業所整理記号'
          safetyDocItem={true}
          data-testid='health_insurance_office_symbol'
        >
          <FormElement>
            <TextInput
              type='text'
              name='health_insurance_office_symbol'
              maxLength={20}
              disabled={readOnly}
              value={
                values.company_branch_insurance.health_insurance_office_symbol
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
            />
          </FormElement>
        </FormListItem>
      )}
      {showHealthInsuranceOfficeNumber() && (
        <FormListItem
          label='健康保険事業所番号'
          safetyDocItem={true}
          data-testid='health_insurance_office_number'
        >
          <FormElement
            validate={
              _.has(
                messages,
                'company_branch_insurance.health_insurance_office_number'
              ) &&
              messages.company_branch_insurance.health_insurance_office_number
            }
          >
            <TextInput
              type='text'
              name='health_insurance_office_number'
              maxLength={20}
              disabled={readOnly}
              value={
                values.company_branch_insurance.health_insurance_office_number
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={() => events.validate('company_branch_insurance')}
            />
          </FormElement>
        </FormListItem>
      )}
      <FormListItem
        label='健康保険加入証明書'
        data-testid='attach_document_type_company_health_insurance'
      >
        <FormElement>
          <AttachDocument
            companyDocuments={_.filter(companyDocuments, document => {
              return (
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.HEALTH_INSURANCE
              );
            })}
            documentCodes={_.filter(documentCodes, document => {
              return (
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.HEALTH_INSURANCE
              );
            })}
            events={events}
            readOnly={readOnly}
            isFormListDefault={true}
            indexId={ATTACH_DOCUMENT_TYPE_COMPANY.HEALTH_INSURANCE}
          />
        </FormElement>
      </FormListItem>
      <FormListSubHeader title='年金保険情報' />
      <FormListItem
        label='年金保険加入状況'
        safetyDocItem={true}
        data-testid='pension_flag'
      >
        <FormElement>
          {_.map(checkboxList.insurance_statuses, (answer, index) =>
            readOnly ? (
              values.company_branch_insurance.pension_flag === answer.value && (
                <span key={index}>{answer.name}</span>
              )
            ) : (
              <div className='form-list-radio__item' key={index}>
                <label className='radio'>
                  <input
                    type='radio'
                    id={`form-radio-pension_flag-${answer.id}`}
                    value={answer.value}
                    name='pension_flag'
                    checked={
                      values.company_branch_insurance.pension_flag ===
                      answer.value
                    }
                    onChange={e =>
                      events.setFormValue('company_branch_insurance', e)
                    }
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>{answer.name}</span>
                </label>
              </div>
            )
          )}
        </FormElement>
      </FormListItem>
      {insuranceStatus.pensionExclusion && (
        <FormListItem
          label='年金保険適用除外理由'
          data-testid='pension_reason_exclusion'
        >
          <FormElement>
            <TextInput
              type='text'
              list='pension_reason_exclusion-list'
              name='pension_reason_exclusion'
              maxLength={255}
              disabled={readOnly}
              value={values.company_branch_insurance.pension_reason_exclusion}
              className='TextInput--combobox'
              onChange={e => events.setFormValue('company_branch_insurance', e)}
            />
            <datalist id='pension_reason_exclusion-list'>
              {_.map(
                comboboxList.pension_insurance_exclusions,
                (option, index) => {
                  return (
                    <option value={option['tekiyoujogai_reason']} key={index}>
                      {option['tekiyoujogai_reason']}
                    </option>
                  );
                }
              )}
            </datalist>
          </FormElement>
        </FormListItem>
      )}
      {insuranceStatus.pensionPresence && (
        <FormListItem label='年金保険種類名称' data-testid='pension_type'>
          <FormElement>
            <TextInput
              type='text'
              list='pension_type-list'
              name='pension_type'
              maxLength={255}
              disabled={readOnly}
              value={values.company_branch_insurance.pension_type}
              className='TextInput--combobox'
              onChange={e => events.setFormValue('company_branch_insurance', e)}
            />
            <datalist id='pension_type-list'>
              {_.map(comboboxList.pension_insurance_types, (option, index) => {
                return (
                  <option value={option['name']} key={index}>
                    {option['name']}
                  </option>
                );
              })}
            </datalist>
          </FormElement>
        </FormListItem>
      )}
      {insuranceStatus.pensionPresence && (
        <FormListItem
          label='年金保険事業所整理記号'
          safetyDocItem={true}
          data-testid='pension_office_symbol'
        >
          <FormElement>
            <TextInput
              type='text'
              name='pension_office_symbol'
              maxLength={20}
              disabled={readOnly}
              value={values.company_branch_insurance.pension_office_symbol}
              onChange={e => events.setFormValue('company_branch_insurance', e)}
            />
          </FormElement>
        </FormListItem>
      )}
      {insuranceStatus.pensionPresence && (
        <FormListItem
          label='年金保険事業所番号'
          safetyDocItem={true}
          data-testid='pension_office_number'
        >
          <FormElement
            validate={
              _.has(
                messages,
                'company_branch_insurance.pension_office_number'
              ) && messages.company_branch_insurance.pension_office_number
            }
          >
            <TextInput
              type='text'
              name='pension_office_number'
              maxLength={20}
              disabled={readOnly}
              value={values.company_branch_insurance.pension_office_number}
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={() => events.validate('company_branch_insurance')}
            />
          </FormElement>
        </FormListItem>
      )}
      <FormListItem
        label='年金保険加入証明書'
        data-testid='attach_document_type_company_pension_insurance'
      >
        <FormElement>
          <AttachDocument
            companyDocuments={_.filter(companyDocuments, document => {
              return (
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.PENSION_INSURANCE
              );
            })}
            documentCodes={_.filter(documentCodes, document => {
              return (
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.PENSION_INSURANCE
              );
            })}
            events={events}
            readOnly={readOnly}
            isFormListDefault={true}
            indexId={ATTACH_DOCUMENT_TYPE_COMPANY.PENSION_INSURANCE}
          />
        </FormElement>
      </FormListItem>
      <FormListSubHeader title='雇用保険情報' />
      <FormListItem
        label='雇用保険加入状況'
        safetyDocItem={true}
        data-testid='employment_insurance_flag'
      >
        <FormElement>
          {_.map(checkboxList.insurance_statuses, (answer, index) =>
            readOnly ? (
              values.company_branch_insurance.employment_insurance_flag ===
                answer.value && <span key={index}>{answer.name}</span>
            ) : (
              <div className='form-list-radio__item' key={index}>
                <label className='radio'>
                  <input
                    type='radio'
                    id={`form-radio-employment_insurance_flag-${answer.id}`}
                    value={answer.value}
                    name='employment_insurance_flag'
                    checked={
                      values.company_branch_insurance
                        .employment_insurance_flag === answer.value
                    }
                    onChange={e =>
                      events.setFormValue('company_branch_insurance', e)
                    }
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>{answer.name}</span>
                </label>
              </div>
            )
          )}
        </FormElement>
      </FormListItem>
      {insuranceStatus.employmentExclusion && (
        <FormListItem
          label='雇用保険適用除外理由'
          data-testid='employment_insurance_reason_exclusion'
        >
          <FormElement>
            <TextInput
              type='text'
              list='employment_insurance_reason_exclusion-list'
              name='employment_insurance_reason_exclusion'
              maxLength={255}
              disabled={readOnly}
              value={
                values.company_branch_insurance
                  .employment_insurance_reason_exclusion
              }
              className='TextInput--combobox'
              onChange={e => events.setFormValue('company_branch_insurance', e)}
            />
            <datalist id='employment_insurance_reason_exclusion-list'>
              {_.map(
                comboboxList.employment_insurance_exclusions,
                (option, index) => {
                  return (
                    <option value={option['tekiyoujogai_reason']} key={index}>
                      {option['tekiyoujogai_reason']}
                    </option>
                  );
                }
              )}
            </datalist>
          </FormElement>
        </FormListItem>
      )}
      {insuranceStatus.employmentPresence && (
        <FormListItem
          label='雇用保険労働保険番号'
          safetyDocItem={true}
          data-testid='employment_insurance_insurance_number'
        >
          <FormElement
            validate={
              _.has(
                messages,
                'company_branch_insurance.employment_insurance_insurance_number'
              ) &&
              messages.company_branch_insurance
                .employment_insurance_insurance_number
            }
          >
            <TextInput
              type='text'
              name='employment_insurance_insurance_number'
              maxLength={20}
              disabled={readOnly}
              value={
                values.company_branch_insurance
                  .employment_insurance_insurance_number
              }
              onChange={e => events.setFormValue('company_branch_insurance', e)}
              onBlur={() => events.validate('company_branch_insurance')}
            />
          </FormElement>
        </FormListItem>
      )}
      <FormListItem
        label='雇用保険加入証明書'
        data-testid='attach_document_type_company_employment_insurance'
      >
        <FormElement>
          <AttachDocument
            companyDocuments={_.filter(companyDocuments, document => {
              return (
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.EMPLOYMENT_INSURANCE
              );
            })}
            documentCodes={_.filter(documentCodes, document => {
              return (
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.EMPLOYMENT_INSURANCE
              );
            })}
            events={events}
            readOnly={readOnly}
            isFormListDefault={true}
            indexId={ATTACH_DOCUMENT_TYPE_COMPANY.EMPLOYMENT_INSURANCE}
          />
        </FormElement>
      </FormListItem>
      <FormListSubHeader title='労災上乗せ保険情報' />
      <FormListItem
        label='加入状況'
        data-testid='worker_add_on_compensation_flag'
      >
        <FormElement>
          {_.map(
            checkboxList.workmans_compensation_insurance_statuses,
            (answer, index) =>
              readOnly ? (
                values.company_branch_insurance
                  .worker_add_on_compensation_flag === answer.value && (
                  <span key={index}>{answer.name}</span>
                )
              ) : (
                <div className='form-list-radio__item' key={index}>
                  <label className='radio'>
                    <input
                      type='radio'
                      id={`form-radio-worker_add_on_compensation_flag-${
                        answer.id
                      }`}
                      value={answer.value}
                      name='worker_add_on_compensation_flag'
                      checked={
                        values.company_branch_insurance
                          .worker_add_on_compensation_flag === answer.value
                      }
                      onChange={e =>
                        events.setFormValue('company_branch_insurance', e)
                      }
                    />
                    <RadioButtonIcon className='icon--2x' />
                    <span>{answer.name}</span>
                  </label>
                </div>
              )
          )}
        </FormElement>
      </FormListItem>
      <FormListSubHeader title='労災保険特別加入制度' />
      <div className='form-list-default__ExceptionalItems'>
        <Description type='primary'>
          <React.Fragment>
            労災保険の特別加入制度（※）に加入されている方のみ入力してください。
            <br />
            ※中小事業主（労働者数300人以下）や一人親方に対して特別に任意加入が認められた労災保険の事です。
            <br />
            労働者向けの一般的な労災保険ではありませんので、ご注意ください。
          </React.Fragment>
        </Description>
      </div>
      <FormListItem
        label='労災保険特別加入状況'
        data-testid='worker_compensation_flag'
      >
        <FormElement>
          {_.map(
            checkboxList.workmans_compensation_insurance_statuses,
            (answer, index) =>
              readOnly ? (
                values.company_branch_insurance.worker_compensation_flag ===
                  answer.value && <span key={index}>{answer.name}</span>
              ) : (
                <div className='form-list-radio__item' key={index}>
                  <label className='radio'>
                    <input
                      type='radio'
                      id={`form-radio-worker_compensation_flag-${answer.id}`}
                      value={answer.value}
                      name='worker_compensation_flag'
                      checked={
                        values.company_branch_insurance
                          .worker_compensation_flag === answer.value
                      }
                      onChange={e =>
                        events.setFormValue('company_branch_insurance', e)
                      }
                    />
                    <RadioButtonIcon className='icon--2x' />
                    <span>{answer.name}</span>
                  </label>
                </div>
              )
          )}
        </FormElement>
      </FormListItem>
      <FormListItem
        label='労災保険特別加入労働保険番号'
        data-testid='worker_compensation_number'
      >
        <FormElement
          validate={
            _.has(
              messages,
              'company_branch_insurance.worker_compensation_number'
            ) && messages.company_branch_insurance.worker_compensation_number
          }
        >
          <TextInput
            type='text'
            list='worker_compensation_number-list'
            name='worker_compensation_number'
            maxLength={20}
            disabled={readOnly}
            value={values.company_branch_insurance.worker_compensation_number}
            onChange={e => events.setFormValue('company_branch_insurance', e)}
            onBlur={() => events.validate('company_branch_insurance')}
          />
        </FormElement>
      </FormListItem>
      <FormListItem
        label='労災保険特別加入整理番号'
        data-testid='worker_compensation_organize_number'
      >
        <FormElement
          validate={
            _.has(
              messages,
              'company_branch_insurance.worker_compensation_organize_number'
            ) &&
            messages.company_branch_insurance
              .worker_compensation_organize_number
          }
        >
          <TextInput
            type='text'
            name='worker_compensation_organize_number'
            maxLength={20}
            disabled={readOnly}
            value={
              values.company_branch_insurance
                .worker_compensation_organize_number
            }
            onChange={e => events.setFormValue('company_branch_insurance', e)}
            onBlur={() => events.validate('company_branch_insurance')}
          />
        </FormElement>
      </FormListItem>
      <FormListItem
        label='労災保険特別加入証明書'
        data-testid='attach_document_type_company_worker_compensation_insurance'
      >
        <FormElement>
          <AttachDocument
            companyDocuments={_.filter(companyDocuments, document => {
              return (
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.LABOR_ACCIDENT_INSURANCE_SPECIAL_ENROLLMENT
              );
            })}
            documentCodes={_.filter(documentCodes, document => {
              return (
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.LABOR_ACCIDENT_INSURANCE_SPECIAL_ENROLLMENT
              );
            })}
            events={events}
            readOnly={readOnly}
            isFormListDefault={true}
            indexId={
              ATTACH_DOCUMENT_TYPE_COMPANY.LABOR_ACCIDENT_INSURANCE_SPECIAL_ENROLLMENT
            }
          />
        </FormElement>
      </FormListItem>
      <FormListSubHeader title='退職金共済情報' />
      <FormListItem label='建退共制度加入状況'>
        <FormElement>
          {_.map(checkboxList.kentaikyo_insurance_statuses, (answer, index) =>
            readOnly ? (
              values.company_branch_insurance.const_subscription_flag ===
                answer.value && <span key={index}>{answer.name}</span>
            ) : (
              <div className='form-list-radio__item' key={index}>
                <label className='radio'>
                  <input
                    type='radio'
                    id={`form-radio-const_subscription_flag-${answer.id}`}
                    value={answer.value}
                    name='const_subscription_flag'
                    checked={
                      values.company_branch_insurance
                        .const_subscription_flag === answer.value
                    }
                    onChange={e =>
                      events.setFormValue('company_branch_insurance', e)
                    }
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>{answer.name}</span>
                </label>
              </div>
            )
          )}
        </FormElement>
      </FormListItem>
      <FormListItem label='建退共契約者番号'>
        <FormElement
          validate={
            _.has(
              messages,
              'company_branch_insurance.const_subscription_number'
            ) && messages.company_branch_insurance.const_subscription_number
          }
        >
          <TextInput
            type='text'
            name='const_subscription_number'
            maxLength={20}
            disabled={readOnly}
            value={values.company_branch_insurance.const_subscription_number}
            onChange={e => events.setFormValue('company_branch_insurance', e)}
            onBlur={() => events.validate('company_branch_insurance')}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='中退共制度加入状況'>
        <FormElement>
          {_.map(checkboxList.chutaikyo_insurance_statuses, (answer, index) =>
            readOnly ? (
              values.company_branch_insurance.enterprise_subscription_flag ===
                answer.value && <span key={index}>{answer.name}</span>
            ) : (
              <div className='form-list-radio__item' key={index}>
                <label className='radio'>
                  <input
                    type='radio'
                    id={`form-radio-enterprise_subscription_flag-${answer.id}`}
                    value={answer.value}
                    name='enterprise_subscription_flag'
                    checked={
                      values.company_branch_insurance
                        .enterprise_subscription_flag === answer.value
                    }
                    onChange={e =>
                      events.setFormValue('company_branch_insurance', e)
                    }
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>{answer.name}</span>
                </label>
              </div>
            )
          )}
        </FormElement>
      </FormListItem>
      <FormListItem label='中退共契約者番号'>
        <FormElement
          validate={
            _.has(
              messages,
              'company_branch_insurance.enterprise_subscription_number'
            ) &&
            messages.company_branch_insurance.enterprise_subscription_number
          }
        >
          <TextInput
            type='text'
            name='enterprise_subscription_number'
            maxLength={20}
            disabled={readOnly}
            value={
              values.company_branch_insurance.enterprise_subscription_number
            }
            onChange={e => events.setFormValue('company_branch_insurance', e)}
            onBlur={() => events.validate('company_branch_insurance')}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='その他退職金共済加入状況'>
        <FormElement>
          {_.map(
            checkboxList.other_subscription_insurance_statuses,
            (answer, index) =>
              readOnly ? (
                values.company_branch_insurance.other_subscription_flag ===
                  answer.value && <span key={index}>{answer.name}</span>
              ) : (
                <div className='form-list-radio__item' key={index}>
                  <label className='radio'>
                    <input
                      type='radio'
                      id={`form-radio-other_subscription_flag-${answer.id}`}
                      value={answer.value}
                      name='other_subscription_flag'
                      checked={
                        values.company_branch_insurance
                          .other_subscription_flag === answer.value
                      }
                      onChange={e =>
                        events.setFormValue('company_branch_insurance', e)
                      }
                    />
                    <RadioButtonIcon className='icon--2x' />
                    <span>{answer.name}</span>
                  </label>
                </div>
              )
          )}
        </FormElement>
      </FormListItem>
      <FormListItem label='その他退職金共済制度名称'>
        <FormElement>
          <TextInput
            type='text'
            name='other_subscription_name'
            maxLength={255}
            disabled={readOnly}
            value={values.company_branch_insurance.other_subscription_name}
            onChange={e => events.setFormValue('company_branch_insurance', e)}
            onBlur={() => events.validate('company_branch_insurance')}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='退職金共済加入証明書'>
        <FormElement>
          <AttachDocument
            companyDocuments={_.filter(companyDocuments, document => {
              return (
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.RETIREMENT_MUTUAL_AID
              );
            })}
            documentCodes={_.filter(documentCodes, document => {
              return (
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.RETIREMENT_MUTUAL_AID
              );
            })}
            events={events}
            readOnly={readOnly}
            isFormListDefault={true}
            indexId={ATTACH_DOCUMENT_TYPE_COMPANY.RETIREMENT_MUTUAL_AID}
          />
        </FormElement>
      </FormListItem>
      <FormListSubHeader title='外国人就労者情報' />
      <FormListItem label='外国人就労者受入有無' safetyDocItem={true}>
        <FormElement>
          {_.map(AcceptanceForeignWorkersFlag, (answer, index) =>
            readOnly ? (
              String(values.company_detail.acceptance_foreign_workers_flag) ===
                String(answer.id) && <span key={index}>{answer.name}</span>
            ) : (
              <div className='form-list-radio__item' key={index}>
                <label className='radio'>
                  <input
                    type='radio'
                    id={`form-radio-acceptance_foreign_workers_flag-${
                      answer.id
                    }`}
                    value={answer.id}
                    name='acceptance_foreign_workers_flag'
                    checked={
                      String(
                        values.company_detail.acceptance_foreign_workers_flag
                      ) === String(answer.id)
                    }
                    onChange={e => events.setFormValue('company_detail', e)}
                  />
                  <RadioButtonIcon className='icon--2x' />
                  <span>{answer.name}</span>
                </label>
              </div>
            )
          )}
        </FormElement>
      </FormListItem>
      <FormListItem label='適正監理計画認定番号'>
        <FormElement>
          <TextInput
            type='text'
            name='certification_number'
            maxLength={20}
            disabled={readOnly}
            value={values.company_branch_foreigner.certification_number}
            onChange={e => events.setFormValue('company_branch_foreigner', e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='受入監理責任者名'>
        <FormElement>
          <TextInput
            type='text'
            name='supervisor_name'
            maxLength={255}
            disabled={readOnly}
            value={values.company_branch_foreigner.supervisor_name}
            onChange={e => events.setFormValue('company_branch_foreigner', e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='受入監理責任者役職名'>
        <FormElement>
          <TextInput
            type='text'
            name='supervisor_position_name'
            maxLength={255}
            disabled={readOnly}
            value={values.company_branch_foreigner.supervisor_position_name}
            onChange={e => events.setFormValue('company_branch_foreigner', e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='就労場所'>
        <FormElement>
          <TextInput
            type='text'
            name='work_place'
            maxLength={255}
            disabled={readOnly}
            value={values.company_branch_foreigner.work_place}
            onChange={e => events.setFormValue('company_branch_foreigner', e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='従事業務内容'>
        <FormElement>
          <TextInput
            type='text'
            name='engagement_content'
            maxLength={255}
            disabled={readOnly}
            value={values.company_branch_foreigner.engagement_content}
            onChange={e => events.setFormValue('company_branch_foreigner', e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='従事開始年月日'>
        {(values.company_branch_foreigner.engagement_start_date ||
          !readOnly) && (
          <DateInput
            dateString={values.company_branch_foreigner.engagement_start_date}
            disabled={readOnly}
            onChangeValue={date =>
              events.setCalendar(
                'company_branch_foreigner',
                'engagement_start_date',
                date
              )
            }
            isPreview={readOnly}
            message={
              _.has(messages, [
                'company_branch_foreigner',
                'engagement_start_date',
              ]) && messages.company_branch_foreigner.engagement_start_date
            }
            onBlur={() => events.validate('company_branch_foreigner')}
            jpDelimiterChar={true}
          />
        )}
      </FormListItem>
      <FormListItem label='従事終了年月日'>
        {(values.company_branch_foreigner.engagement_end_date || !readOnly) && (
          <DateInput
            dateString={values.company_branch_foreigner.engagement_end_date}
            disabled={readOnly}
            onChangeValue={date =>
              events.setCalendar(
                'company_branch_foreigner',
                'engagement_end_date',
                date
              )
            }
            isPreview={readOnly}
            message={
              _.has(messages, [
                'company_branch_foreigner',
                'engagement_end_date',
              ]) && messages.company_branch_foreigner.engagement_end_date
            }
            onBlur={() => events.validate('company_branch_foreigner')}
            jpDelimiterChar={true}
          />
        )}
      </FormListItem>
      <FormListItem label='添付書類'>
        <FormElement>
          <AttachDocument
            companyDocuments={_.filter(companyDocuments, document => {
              return (
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.APPROPRIATE_MANAGEMENT_PLAN
              );
            })}
            documentCodes={_.filter(documentCodes, document => {
              return (
                document.file_typeL ===
                  ATTACH_DOCUMENT_TYPE_COMPANY.APPROPRIATE_MANAGEMENT_PLAN &&
                document.file_typeS !== '020' // do not show document typeS 020 of UPL100 for prime company
              );
            })}
            events={events}
            readOnly={readOnly}
            isFormListDefault={true}
            indexId={ATTACH_DOCUMENT_TYPE_COMPANY.APPROPRIATE_MANAGEMENT_PLAN}
          />
        </FormElement>
      </FormListItem>
    </FormList>
  );
};



// WEBPACK FOOTER //
// ./src/components/forms/PrimeCompany.jsx